<script>
import CheckMark from "../../core/Checkmark.vue";

export default {
    name: "StageComplete",
    components: {CheckMark},
    props:['message','error']
}
</script>

<template>
    <div class="text-center text-white pt-6 mt-6" style="height: 30vw">
        <transition name="bounce">
            <div v-if="message && !error">
                <CheckMark class="p-6"/>
                <h5 class="text-5">{{message}}</h5>
            </div>
        </transition>
    </div>
</template>

<style scoped>

</style>
